function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8SewingTapeMeasure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.8489,
    y1: 26.1296,
    x2: 26.7872,
    y2: 45.1553
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEDE00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5AA00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M6,34c0,2.766,2.112,4.633,6.085,5l26.708,2.771C39.973,41.893,41,40.968,41,39.782v-4.979 c0-1.025-0.774-1.884-1.794-1.989L12.085,30C9.069,29.585,6.574,28.34,6,25V34z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.9176,
    y1: 19.3207,
    x2: 22.2017,
    y2: 4.4153,
    gradientTransform: "matrix(-1 0 0 -1 46 25)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEDE00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5AA00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M40,14c0-2.766-2.112-4.633-6.085-5L7.206,6.229C6.027,6.107,5,7.032,5,8.218v4.979 c0,1.025,0.774,1.884,1.794,1.989L33.915,18c3.016,0.415,5.511,1.66,6.085,5V14z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.9222,
    y1: 15.9812,
    x2: 24.0955,
    y2: 31.9273
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEDE00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5AA00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M33.915,18.779l-17.915,1v0.003L12.085,20C8.112,20.367,6,22.234,6,25v9 c0.574-3.34,3.069-4.585,6.085-5L30,28v-0.003l3.915-0.219c3.973-0.367,6.085-2.234,6.085-5v-9 C39.426,17.119,36.931,18.364,33.915,18.779z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98E00"
    },
    d: "M18,30.614v1.764c0,0.552,0.448,1,1,1s1-0.448,1-1v-1.556L18,30.614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98E00"
    },
    d: "M14,30.199v1.706c0,0.552,0.448,1,1,1s1-0.448,1-1v-1.498L14,30.199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98E00"
    },
    d: "M10,29.572v3.806c0,0.552,0.448,1,1,1s1-0.448,1-1v-3.391C11.342,29.893,10.665,29.758,10,29.572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98E00"
    },
    d: "M34,32.274V36c0,0.552,0.448,1,1,1s1-0.448,1-1v-3.519L34,32.274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98E00"
    },
    d: "M22,31.029V35c0,0.552,0.448,1,1,1s1-0.448,1-1v-3.764L22,31.029z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98E00"
    },
    d: "M30,31.859v1.806c0,0.552,0.448,1,1,1s1-0.448,1-1v-1.599L30,31.859z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98E00"
    },
    d: "M26,31.444v1.748c0,0.552,0.448,1,1,1s1-0.448,1-1v-1.54L26,31.444z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98E00"
    },
    d: "M18,19.667v1.716c0,0.552,0.448,1,1,1s1-0.448,1-1v-1.828L18,19.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98E00"
    },
    d: "M14,21.569c0,0.552,0.448,1,1,1s1-0.448,1-1v-1.788l-2,0.112V21.569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98E00"
    },
    d: "M10,20.364v3.444c0,0.552,0.448,1,1,1s1-0.448,1-1v-3.797C11.299,20.081,10.633,20.205,10,20.364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98E00"
    },
    d: "M34,18.765v3.474c0,0.552,0.448,1,1,1s1-0.448,1-1v-3.889C35.335,18.537,34.658,18.672,34,18.765z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98E00"
    },
    d: "M30,18.997v1.482c0,0.552,0.448,1,1,1s1-0.448,1-1v-1.593L30,18.997z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98E00"
    },
    d: "M22,19.444V23c0,0.552,0.448,1,1,1s1-0.448,1-1v-3.668L22,19.444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98E00"
    },
    d: "M26,19.22v1.444c0,0.552,0.448,1,1,1s1-0.448,1-1v-1.556L26,19.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98E00"
    },
    d: "M14,6.934v1.875c0,0.552,0.448,1,1,1s1-0.448,1-1V7.141L14,6.934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98E00"
    },
    d: "M10,6.519v3.955c0,0.552,0.448,1,1,1s1-0.448,1-1V6.726L10,6.519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98E00"
    },
    d: "M18,7.349V9.09c0,0.552,0.448,1,1,1s1-0.448,1-1V7.556L18,7.349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98E00"
    },
    d: "M34,9.011V13c0,0.552,0.448,1,1,1s1-0.448,1-1V9.357C35.368,9.198,34.7,9.079,34,9.011z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98E00"
    },
    d: "M30,8.594v1.88c0,0.552,0.448,1,1,1s1-0.448,1-1V8.801L30,8.594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98E00"
    },
    d: "M22,7.764v3.853c0,0.552,0.448,1,1,1s1-0.448,1-1V7.971L22,7.764z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98E00"
    },
    d: "M26,8.179V10c0,0.552,0.448,1,1,1s1-0.448,1-1V8.386L26,8.179z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.2369,
    y1: 4.9004,
    x2: 6.7757,
    y2: 16.1916
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#889097"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#64717C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    d: "M6,16L6,16c-1.105,0-2-0.895-2-2V7c0-1.105,0.895-2,2-2h0c1.105,0,2,0.895,2,2v7 C8,15.105,7.105,16,6,16z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.2369,
    y1: 31.9004,
    x2: 40.7757,
    y2: 43.1916
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#889097"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#64717C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    d: "M40,43L40,43c-1.105,0-2-0.895-2-2v-7c0-1.105,0.895-2,2-2h0c1.105,0,2,0.895,2,2v7 C42,42.105,41.105,43,40,43z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8SewingTapeMeasure);
export default __webpack_public_path__ + "static/media/icons8-sewing-tape-measure.c687038e1ad21bb52c15e132211e58c4.svg";
export { ForwardRef as ReactComponent };